import { render, staticRenderFns } from "./MainSlope.vue?vue&type=template&id=3abc5ea8&"
import script from "./MainSlope.vue?vue&type=script&lang=js&"
export * from "./MainSlope.vue?vue&type=script&lang=js&"
import style0 from "./MainSlope.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports